import { useCallback, useMemo } from 'react';

import { Label } from '@components/ui/label';
import { Switch } from '@components/ui/switch';

import { useHidratacaoQueimado } from '../../context';
import type { IArea } from '../../context/IUseHidratacaoQueimado';

interface IProps {
  data: IArea;
}

const CalculateSCQItem = ({ data }: IProps) => {
  const { age, changeAreaSelected } = useHidratacaoQueimado();

  const percentage = useMemo<string>(() => {
    if (!data.isSelected) {
      return '-';
    }
    if (age >= 14) {
      if (data.adultPercentage) {
        return data.adultPercentage.toFixed(1);
      } else {
        return '-';
      }
    } else {
      if (data.childrenPercentage) {
        return data.childrenPercentage.toFixed(1);
      } else {
        return '-';
      }
    }
  }, [age, data.adultPercentage, data.childrenPercentage, data.isSelected]);

  const handleChangeSwitch = useCallback((): void => {
    changeAreaSelected(data);
  }, [changeAreaSelected, data]);

  return (
    <div className="flex flex-row gap-12">
      <Label className="w-36" htmlFor={data.name}>
        {data.name}
      </Label>

      <Switch
        checked={data.isSelected}
        className="data-[state=checked]:bg-tertiary cursor-pointer"
        id={data.name}
        onCheckedChange={() => handleChangeSwitch()}
      />

      <Label className="w-8 text-center">{percentage}</Label>
    </div>
  );
};

export default CalculateSCQItem;
